/**
 * GradeCtaStrip — bottom-of-page conversion strip with a repeat call to
 * action. Sits below the FAQ and re-anchors users back to the scanner.
 */
import React from 'react';

export default function GradeCtaStrip({ onStart }) {
  return (
    <section className="gp-section">
      <div className="gp-cta-strip">
        <h2 className="gp-h2">Ready to grade your card?</h2>
        <p className="gp-lead">No sign-up. No paywall. Three angles per side, six photos, and a full PSA-style report in seconds.</p>
        <button type="button" className="gp-btn gp-btn--primary gp-btn--xl" onClick={onStart}>
          Grade your card now
        </button>
      </div>
    </section>
  );
}
